import React, {useState, useEffect} from 'react'
import {Modal } from 'react-bootstrap'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import moment from 'moment'


import DashBoardContainer from '../../components/containers/dashboardContainer'
import ReviewCard from '../../components/reviewCard'
import {fetchIndividualApplicationReport, fetchFile} from '../../actions'
import {
    FETCH_INDIVIDUAL_APPLICATION_ID,
    GENERATE_FILE_STRING_ID
} from '../../store/loaders'
import LoadingSpinner from '../../components/loadingSpiner'
import download_icon from '../../assets/images/icons/download-icon.png'


const ApplicationStatusModel = (props)=>{


    const history = useHistory()
    const dispatch = useDispatch()

    const apiResponse = useSelector(state=>{
        const {individualApplicationReport, loader, fetchFile} = state
        const {application} = individualApplicationReport
        const {isLoading} = loader[FETCH_INDIVIDUAL_APPLICATION_ID] || { isLoading: false}
        const {file} = fetchFile
        const fileLoader = loader[GENERATE_FILE_STRING_ID] 
        return {
            application,
            isLoading,
            file,
            fileLoader
        }
    })

    const [status, setStatus] = useState('')
    const [hasDownloaded, setHasDownloaded] = useState(false)
    const [download, setDownload] = useState(false)

    const handleSubmit = ()=>{
        history.goBack()
    }
    
    const data = apiResponse?.application
    const actionLoader = apiResponse.isLoading


    useEffect(()=>{
        if(props.data && props.data.paymentReference === undefined){
            const {id} = props.data
            setStatus(props.data?.clientStatus || props.data?.status)
            dispatch(fetchIndividualApplicationReport(id))
        }
        if(props.data?.paymentReference){
            const {paymentReference} = props.data
            setStatus(props.data.itemType)
            dispatch(fetchIndividualApplicationReport(paymentReference))
            
        }
    },[props.data])


    useEffect(()=>{
        if(apiResponse.file?.fileText != null && !hasDownloaded && download){
            var a = document.createElement("a");
            a.href =  "data:image/" +apiResponse.file?.type +";base64," + apiResponse.file?.fileText; 
            a.download = apiResponse.file?.name || 'File' + "." + apiResponse.file?.type || ''; 
            a.click();
            setHasDownloaded(true)
        }
    },[apiResponse.file])


    const downloadIdFile = ()=>{
        let url  
        if(data?.documentFile?.fileText !== '' && data?.documentFile?.fileText !== undefined ){
            url = encodeURIComponent(data.documentFile?.fileText.substring(data.documentFile?.fileText.indexOf("/tmp"), data.documentFile?.fileText.length))
            dispatch(fetchFile(url))
        }
        setDownload(true)
        setHasDownloaded(false)
    }

    const downloadCv  = ()=>{
        let url  
        if(data?.cv?.fileText !== '' && data?.cv?.fileText !== undefined ){
            url = encodeURIComponent(data.cv?.fileText.substring(data.cv?.fileText.indexOf("/tmp"), data.cv?.fileText.length))
            dispatch(fetchFile(url))
        }
        setDownload(true)
        setHasDownloaded(false)
    }

    const  downloadReport = ()=>{
        let url  
        if(data?.technicalReportFile?.fileText !== '' && data?.technicalReportFile?.fileText !== undefined ){
            url = encodeURIComponent(data.technicalReportFile?.fileText.substring(data.technicalReportFile?.fileText.indexOf("/tmp"), data.technicalReportFile?.fileText.length))
            dispatch(fetchFile(url))
        }
        setDownload(true)
        setHasDownloaded(false)
    }

    const downloadFile = (value)=>{
        let url 
        if(value.awardDocumentFile){
            if(value?.awardDocumentFile?.fileText !== '' && value?.awardDocumentFile?.fileText !== undefined ){
                url = encodeURIComponent(value.awardDocumentFile?.fileText.substring(value.awardDocumentFile?.fileText.indexOf("/tmp"), value.awardDocumentFile?.fileText.length))
                dispatch(fetchFile(url))
            }
        }
        if(value.certificateDocumentFile){
            if(value?.certificateDocumentFile?.fileText !== '' && value?.certificateDocumentFile?.fileText !== undefined ){
                url = encodeURIComponent(value.certificateDocumentFile?.fileText.substring(value.certificateDocumentFile?.fileText.indexOf("/tmp"), value.certificateDocumentFile?.fileText.length))
                dispatch(fetchFile(url))
            }
        }
        setDownload(true)
        setHasDownloaded(false)
    }

    const handleCancel = ()=>{
        props.hide()
     }
    return(
        <Modal
            show={props.show} 
            onHide={props.hide}
            centered
            size="xl">
                {!actionLoader ?
    (
        <div>
            <DashBoardContainer 
                handleSubmit={handleSubmit}
                handleClose={handleCancel}
                borderLess={true}
                title="Submit"
                hasmiddleBtn={true}
                loader={apiResponse.fileLoader?.isLoading}
                hasButton={true}
                hasCloseBtn={true}
                closeTitle="Close"
                >
            <div className="application-status-sub-header mt-4">
                <div className="content">
                    <span className="title" style={{textAlign: 'center', fontSize: 14}}>Individual Membership Application</span>
                    <span className="title-content" style={{textAlign: 'center'}}>{data?.membershipClassId?.name}</span>
                </div>
            </div>
            <div className="application-status-container mt-2 mb-4">
                <span className="general-span-text-none-auto-small" style={{fontSize: 14}}>Application Status</span>
                <span className="general-span-text-none-auto">{status}</span>
            </div>
            <div className="dashboard-review-container">
                <div>
                    <ReviewCard
                        title="Personal details"
                        path="/applicant/personal-details"
                        state={apiResponse.application}
                        hasEdit={status === 'not submitted' ?  false : true}
                        >
                        <div className="review-details-content-conatiner mt-2">
                            <div className="review-details-profile-container">
                                <div className="review-details-profile-icon">
                                    {data?.portraitPhotoFile && <img src={`data:image/${data?.portraitPhotoFile?.type};base64,${data?.portraitPhotoFile?.fileText}`} style={{width: '100%', height: '80%'}}/>}
                                </div>
                                <div>
                                    <div>
                                        <span>Title</span>
                                        <p>{data?.title}</p>
                                    </div>
                                    <div>
                                        <span>Surname</span>
                                        <p>{data?.lastname}</p>
                                    </div>
                                    <div>
                                        <span>Other names</span>
                                        <p>{data?.firstname}</p>
                                    </div>
                                    <div>
                                        <span>Gender</span>
                                        <p>{data?.gender}</p>
                                    </div>
                                </div>
                            </div>

                            <div className="review-details-gender-details">
                                
                                <div>
                                    <span>Date of Birth</span>
                                    <p>{data?.dateOfBirth && moment(data?.dateOfBirth)?.format('MMMM Do YYYY')}</p>
                                </div>
                                <div>
                                    <span>Nationality</span>
                                    <p>{data?.countryForm?.name}</p>
                                </div>
                                <div>
                                    <span>Discipline</span>
                                    <p>{data?.discipline?.name}</p>
                                </div>
                                <div>
                                    <span>Education Level</span>
                                    <p>{data?.awardType?.name}</p>
                                </div>
                            </div>

                            <div className="review-details-id-type">
                                <div>
                                    <span>ID Type</span>
                                    <p>{data?.identificationDocumentType}</p>

                                </div>
                                <div>
                                    <span>ID number</span>
                                    <p>{data?.identificationDocumentNumber}</p>
                                </div>

                                <div className="review-details-id-card-container">
                                    <span>ID card scan attached </span>
                                    {/* <img src={`data:image/${data?.documentFile?.type};base64,${data?.documentFile?.fileText}`}/> */}
                                    <div className="d-flex">
                                        <p>{data?.documentFile?.name}</p>
                                       { data?.documentFile && <img 
                                        src={download_icon} 
                                        onClick={downloadIdFile}
                                        style={{height: 40, width: 40, padding: 5, marginLeft: 10, cursor: 'pointer', marginTop: '-10px'}}/>}
                                    </div>
                                </div>
                                <div className="review-details-id-card-container">
                                    <span>CV </span>
                                    <div className="d-flex">
                                        <p>{data?.cv?.name}</p>
                                     { data?.cv && <img 
                                            src={download_icon} 
                                            onClick={downloadCv}
                                            style={{height: 40, width: 40, padding: 5, marginLeft: 10, cursor: 'pointer', marginTop: '-10px'}}/>}
                                    </div>
                                </div>
                                { data?.technicalReportFile &&  
                                <div className="review-details-id-card-container">
                                    <span>Technical Report</span>
                                    <div className="d-flex">
                                        <p>{data?.technicalReportFile?.name}</p>
                                     <img 
                                            src={download_icon} 
                                            onClick={downloadReport}
                                            style={{height: 40, width: 40, padding: 5, marginLeft: 10, cursor: 'pointer', marginTop: '-10px'}}/>
                                    </div>
                            </div>}
                            </div>
                            
                        </div>
                    </ReviewCard>

                    <ReviewCard
                        title="Contact details"
                        path="/applicant/contact-details"
                        hasEdit={status === 'not submitted' ?  false : true}
                        >
                            <div className="review-details-content-conatiner">
                                <div className="review-details-contact-container-first">
                                    <div className="d-flex">
                                        <div className="contancts-container">
                                            <div>
                                                <span>Main Phone Number</span>
                                                <p>{data?.contactTelephoneNumber || '-'}</p>
                                            </div>
                                        </div>
                                        <div className="">
                                            <div>
                                                <span>Main Email Address</span>
                                                <p>{data?.contactEmail || '-'}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="seperator-contact"></div>
                                    <div className="d-flex">
                                        <div className="contancts-container">
                                            <div>
                                                <span>Next of Kin Phone Number</span>
                                                <p>{data?.secondaryContactTelephoneNumber || '-'}</p>
                                            </div>
                                        </div>
                                        <div className="">
                                            <div>
                                                <span>Next of Kin Email Address</span>
                                                <p>{data?. secondaryContactEmail || ''}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="review-details-contact-container-second">
                                    <div className="">
                                        <div>
                                            <span>Residence Address</span>
                                            <p>{data?.provinceId?.name}, {data?.districtId?.name}, {data?.sectorId?.name}, {data?.cellId?.name}, {data?.villageId?.name}, {data?.streetOrHouseNumber}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </ReviewCard>

                    <ReviewCard
                        title="Educational details"
                        path="/applicant/educational-details"
                        hasEdit={status === 'not submitted' ?  false : true}
                        >
                            <div className="review-details-content-conatiner">
                                <div className="review-details-contact-container-first" style={{width: '100%'}}>
                                    {data?.educationDetails?.length> 0 && 
                                    <div>
                                        {data?.educationDetails.map(value=>{
                                            return(
                                                <div className="d-flex dashboarder-grey-contanier mt-4" style={{justifyContent: 'space-between'}}>
                                                    <div>
                                                        <div>
                                                            <span>Institution Name</span>
                                                            <p>{value.institutionName}</p>
                                                        </div>
                                                    </div>
                                                    <div className="">
                                                        <div>
                                                            <span>Award Type</span>
                                                            <p>{value.awardType?.name}</p>
                                                        </div>
                                                    </div>
                                                    <div className="">
                                                        <div>
                                                            <span>Year of Award</span>
                                                            <p>{value.yearOfAward}</p>
                                                        </div>
                                                    </div>
                                                    <div className="mb-4">
                                                        <div>
                                                            <span>Certified Award Attached</span>
                                                            <div className="d-flex" style={{alignItems: 'center'}}>
                                                                <p>{value.awardDocumentFile?.name}</p>
                                                                {value.awardDocumentFile?.name && <img 
                                                                    src={download_icon} 
                                                                    onClick={()=>downloadFile(value)}
                                                                    style={{height: 40, width: 40, padding: 5, marginLeft: 10, cursor: 'pointer', marginTop: '-20px'}}/>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    <div className="seperator-contact" style={{width:'100%'}}></div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </ReviewCard>
                    <ReviewCard
                        title="CERTIFICATION DETAILS"
                        path="/applicant/certificate-details"
                        hasEdit={status === 'not submitted' ?  false : true}
                        >
                        <div className="review-details-content-conatiner">
                                <div className="review-details-contact-container-first" style={{width: '100%'}}>
                                    {data?.professionalCertificates?.length > 0 && 
                                    <div>
                                        {data?.professionalCertificates.map(value=>{
                                            return(
                                                <div className=" dashboarder-grey-contanier mt-4" style={{display: 'flex', flexDirection: 'column'}}>
                                                    <div className="d-flex" style={{justifyContent: 'space-between'}}>   
                                                        <div>
                                                            <div>
                                                                <span>Certificate Name</span>
                                                                <p>{value.name}</p>
                                                            </div>
                                                        </div>
                                                        <div className="">
                                                            <div>
                                                                <span>Provider</span>
                                                                <p>{value.provider}</p>
                                                            </div>
                                                        </div>
                                                        <div className="">
                                                            <div>
                                                                <span>Location</span>
                                                                <p>{value.location}</p>
                                                            </div>
                                                        </div>
                                                        <div className="">
                                                            <div>
                                                                <span>Start Date</span>
                                                                <p>{moment(value.endDate).format('MMMM Do YYYY')}</p>
                                                            </div>
                                                        </div>
                                                        <div className="">
                                                            <div>
                                                                <span>End Date</span>
                                                                <p>{moment(value.endDate).format('MMMM Do YYYY')}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                
                                                    <div>
                                                        <div className="mb-4">
                                                            <div>
                                                                <span>Certified Award Attached</span>
                                                                <div className="d-flex">
                                                                    <p>{value.certificateDocumentFile?.name}</p>
                                                                    {value.certificateDocumentFile?.name && <img 
                                                                        src={download_icon} 
                                                                        onClick={()=>downloadFile(value)}
                                                                        style={{height: 40, width: 40, padding: 5, marginLeft: 10, cursor: 'pointer', marginTop: '-10px'}}/>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            )
                                        })}
                                        <div className="seperator-contact" style={{width:'100%'}}></div>
                                    </div>}
                                </div>
                            </div>
                        </ReviewCard>

                        <ReviewCard
                            title="REFERENCES DETAILS"
                            path="/applicant/reference-details"
                            hasEdit={status === 'not submitted' ?  false : true}>
                                 <div className="review-details-content-conatiner">
                                <div className="review-details-contact-container-first" style={{width: '100%'}}>
                                    {data?.professionalReferences?.length > 0 && 
                                    <div>
                                        {data?.professionalReferences.map(value=>{
                                            return(
                                                <div className="d-flex dashboarder-grey-contanier mt-4" style={{justifyContent: 'space-between'}}>
                                                    <div>
                                                        <div>
                                                            <span>Full Names</span>
                                                            <p>{value.name}</p>
                                                        </div>
                                                    </div>
                                                    <div className="">
                                                        <div>
                                                            <span>Member Grade</span>
                                                            <p>{value.memberGradeId}</p>
                                                        </div>
                                                    </div>
                                                    <div className="">
                                                        <div>
                                                            <span>Member Number</span>
                                                            <p>{value.ierMemberNumber}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </div>}
                                   
                                    <div className="seperator-contact" style={{width:'100%'}}></div>
                                    {data?.academicReferences?.length >0 && 
                                        <div>
                                            {data?.academicReferences.map(value=>{
                                                return(
                                                    <div className="d-flex dashboarder-grey-contanier mt-4" style={{justifyContent: 'space-between'}}>
                                                        <div>
                                                            <div>
                                                                <span>Full Names</span>
                                                                <p>{value.name}</p>
                                                            </div>
                                                        </div>
                                                        <div className="">
                                                            <div>
                                                                <span>Phone Number</span>
                                                                <p>{value.telephoneNumber}</p>
                                                            </div>
                                                        </div>
                                                        <div className="">
                                                            <div>
                                                                <span>Email Address</span>
                                                                <p>{value.email}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    }
                                </div>
                            </div>
                        </ReviewCard>
                </div>
            </div>
        </DashBoardContainer>
        </div>
    )
    :
    (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'}}>
            <LoadingSpinner
                color={'#1D834F'}/>
        </div>
    )
    }
        </Modal>
    )
}

export default ApplicationStatusModel